
// import isStringOrStringArray from '@/utils/isStringOrStringArray'
import { categories } from '@/common/material-metadata';

export default {
  name: 'CategorySelector',

  componentName: 'CategorySelector',

  props: {
    config: {
      type: Object,
      required: true
    },
    formValue: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {
      categories: categories
    };
  }
};